import FormattedMessage from 'I18n/components/FormattedMessage';
import { BREEZE_TOOLTIP_DELAY } from 'chatspot-core/constants/Delays';
import { SimpleBotIcon } from 'foundations-assets/icons/components/SimpleBotIcon';
import { Image } from 'foundations-components/transitional/components/Image';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/transitional/components/View';
import { resolveAgentIconName } from '../../utils/agentIconUtils';
import { AgentInitialsIcon } from './internal/AgentInitialsIcon';
import { AgentNamedIcon } from './internal/AgentNamedIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AgentTooltip = ({
  title,
  children
}) => /*#__PURE__*/_jsx(Tooltip, {
  delay: BREEZE_TOOLTIP_DELAY,
  title: title,
  children: children
});
export const AgentIconWithFallback = ({
  size,
  name,
  iconName,
  welcomeMessage,
  iconUrl,
  loading,
  marginBlockEnd = '400',
  borderRadius,
  background = 'gradient'
}) => {
  const resolvedIconName = resolveAgentIconName(iconName);
  const hasNamedIcon = typeof iconName === 'string' && iconName.length > 0;
  const hasName = typeof name === 'string' && name.length > 0;
  const nameTooltip = hasName ? /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(View, {
      children: name
    }), welcomeMessage && /*#__PURE__*/_jsx(View, {
      marginBlockStart: "200",
      children: welcomeMessage
    })]
  }) : null;
  if (hasNamedIcon) {
    const namedIcon = /*#__PURE__*/_jsx(AgentNamedIcon, {
      Icon: resolvedIconName ? undefined : SimpleBotIcon,
      iconName: resolvedIconName,
      marginBlockEnd: marginBlockEnd,
      size: size,
      background: "none",
      testId: "agent-named-icon"
    });
    if (nameTooltip) {
      return /*#__PURE__*/_jsx(AgentTooltip, {
        title: nameTooltip,
        children: namedIcon
      });
    }
    return namedIcon;
  }
  if (typeof iconUrl === 'string' && iconUrl.length > 0) {
    return /*#__PURE__*/_jsx(Image, {
      alt: name,
      blockSize: `${size}px`,
      inlineSize: `${size}px`,
      loading: loading,
      marginBlockEnd: marginBlockEnd,
      borderRadius: "300",
      src: iconUrl,
      objectFit: "cover"
    });
  }
  if (hasName) {
    return /*#__PURE__*/_jsx(AgentTooltip, {
      title: nameTooltip,
      children: /*#__PURE__*/_jsx(AgentInitialsIcon, {
        agentName: name,
        borderRadius: borderRadius,
        marginBlockEnd: marginBlockEnd,
        size: size,
        background: background
      })
    });
  }
  return /*#__PURE__*/_jsx(AgentTooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "aiComponentsUiLibrary.components.icon.agentIconWithFallback.breezeAssistant"
    }),
    children: /*#__PURE__*/_jsx(AgentNamedIcon, {
      Icon: SimpleBotIcon,
      marginBlockEnd: marginBlockEnd,
      size: size,
      borderRadius: borderRadius,
      background: background,
      testId: "agent-fallback-icon"
    })
  });
};
AgentIconWithFallback.displayName = 'AgentIconWithFallback';